import { Context } from '../..';
import * as base from '../base';
import { Entity } from '../../../models/view/entity';
import { AdditionalLearningViewModel, AdditionalLearningSearchRequest, AdditionalLearningListViewModel } from '../../../pages/learning-journey/additional-learning/additional-learning.models';

export async function deleteAdditionalLearning(context: Context, slug: string): Promise<void> {
  const request: base.IRequest = { url: base.apiURL(`offplatformlearning`, `remove-off-platform-learning`, slug), authenticated: true, method: 'DELETE' };
  await base.request(request);
}

export async function saveAdditionalLearning(context: Context, offPlatformLearningDetailViewModel: AdditionalLearningViewModel): Promise<number | undefined> {
  const request: base.IRequest = { url: base.apiURL(`offplatformlearning`, `save-off-platform-learning`), authenticated: true, method: 'POST', body: JSON.stringify(offPlatformLearningDetailViewModel) };
  const response: base.IResponse<number> = await base.request(request);
  return response.data;
}

export async function getAdditionalLearning(context: Context, slug: string): Promise<AdditionalLearningViewModel | undefined> {
  const request: base.IRequest = { url: base.apiURL(`offplatformlearning`, `get-off-platform-learning`, slug), authenticated: true };
  const response: base.IResponse<AdditionalLearningViewModel> = await base.request(request);

  return response.data;
}

export async function getAdditionalLearningList(context: Context, params: AdditionalLearningSearchRequest): Promise<AdditionalLearningListViewModel[] | undefined> {
  const queryEntries = Object.entries(params);
  const search = new URLSearchParams(queryEntries);

  const request: base.IRequest = { url: base.apiURL(`offplatformlearning`, `get-off-platform-learning-list?${search.toString()}`), authenticated: true };
  const response: base.IResponse<AdditionalLearningListViewModel[]> = await base.request(request);

  return response.data;
}

export async function searchLearnerSkills(context: Context, searchTerm: string): Promise<Entity[] | undefined> {
  const request: base.IRequest = { url: base.apiURL(`learnerskill`, `search-learner-skills?searchTerm=${searchTerm}`), authenticated: true };
  const response: base.IResponse<Entity[]> = await base.request(request);

  return response.data;
}
